export default __webpack_public_path__ + "static/media/nf-2.c7a4ba8a.png";